<section class="overflow-x-auto p-6 bg-white rounded-xl shadow">
  <div class="title text-lg font-semibold mb-4">
    {{ 'applications.title' | translate }}
    <span class="ml-2 bg-gray-200 text-gray-700 px-4 py-1 rounded-full text-sm">
      {{ rows.length }}
    </span>
  </div>

  <table mat-table [dataSource]="rows" class="mat-elevation-z1 w-full">

    <!-- Title -->
    <ng-container matColumnDef="title">
      <th mat-header-cell *matHeaderCellDef>Application</th>
      <td mat-cell *matCellDef="let row">
        <div class="row flex items-center gap-2">
          <span class="name">{{ row.offer.title }}</span>
        </div>
      </td>
    </ng-container>

    <!-- Company -->
    <ng-container matColumnDef="companyName">
      <th mat-header-cell *matHeaderCellDef>Company name</th>
      <td mat-cell *matCellDef="let row">
        <div class="flex items-center gap-2">
          <span class="language bg-gray-100 text-gray-700 py-1 px-2 rounded text-xs">
            {{ row.offer.companyName }}
          </span>
        </div>
      </td>
    </ng-container>

    <!-- Country -->
    <ng-container matColumnDef="country">
      <th mat-header-cell *matHeaderCellDef>{{ 'applications.country' | translate }}</th>
      <td mat-cell *matCellDef="let row">
        <div class="flex items-center gap-2">
          <span class="flag-emoji">{{ getFlagEmoji(row.offer.location) }}</span>
          <span class="country text-gray-700">&nbsp; {{ row.offer.location }}</span>
        </div>
      </td>
    </ng-container>

    <!-- Date (from application) -->
    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef>{{ 'applications.appliedDate' | translate }}</th>
      <td mat-cell *matCellDef="let row" class="text-gray-600 date">
        {{ row.app.appliedAt | date: 'EEE, dd MMM yyyy – h:mma' }}
      </td>
    </ng-container>

    <!-- Status (from application) -->
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>{{ 'applications.processStatus' | translate }}</th>
      <td mat-cell *matCellDef="let row">
        <span class="status-badge" [ngClass]="{
          'status-application': row.app.status === 'PENDING',
          'status-shortlisted': row.app.status === 'SHORTLISTED',
          'status-interview': row.app.status === 'INVITED_TO_INTERVIEW',
          'status-under-review': row.app.status === 'INTERVIEWED',
          'status-offered': row.app.status === 'OFFERED',
          'status-hired': row.app.status === 'ACCEPTED',
          'status-rejected': row.app.status === 'REJECTED'
        }">
          {{ ('applications.status.' + row.app.status) | translate }}
        </span>
      </td>
    </ng-container>

    <!-- Actions -->
    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef>{{ 'applications.action' | translate }}</th>
      <td mat-cell *matCellDef="let row">
        <app-application-actions
          (click)="$event.stopPropagation()"
          [app]="row.app"
          [isMobile]="false"
          [jobOfferId]="row.offer.companyId"
          variant="menu"
          role="candidate">
        </app-application-actions>

      </td>
    </ng-container>

    <!-- Rows -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row
        *matRowDef="let row; columns: displayedColumns"
        (click)="navigateToApplication(row.app)"
        style="cursor: pointer;">
    </tr>
  </table>
</section>
